<template>
  <div>
    <div class="AutoScalingMonitor-title">
      <div>{{ $t("alarms.autoscaling.autoscaling") }}</div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.autoscaling.autoscalingList')">
          <div class="AutoScalingMonitor-top">
            <autoscaling-monitor-search></autoscaling-monitor-search>
          </div>
          <table-autoscaling></table-autoscaling>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import AutoscalingMonitorSearch from "../autoscaling/AutoscalingMonitorSearch";
import TableAutoscaling from "../autoscaling/TableAutoscaling";
import LogWarningSearch from "../logs/log/LogWarningSearch";
import TableLogWarning from "../logs/log/TableLogWarning";

export default {
  name: "AutoscalingMonitor",
  components: {
    AutoscalingMonitorSearch,
    TableAutoscaling,
    LogWarningSearch,
    TableLogWarning,
  },
  data() {
    return {
      currentTab: "",
    };
  },
  methods: {},
};
</script>

<style scoped>
.AutoScalingMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.AutoScalingMonitor-title > div:nth-child(1) {
  float: left;
}
.AutoScalingMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.AutoScalingMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/autoscaling/AutoscalingMonitor.vue